import { Component, Inject } from '@angular/core';
import { ProductsList } from '@icc/b2b/shared';
import { DialogRef, DIALOG_DATA } from '@icc/ui';

@Component({
    selector: 'icc-own-products-dialog',
    templateUrl: './own-products-dialog.component.html',
    styleUrls: ['./own-products-dialog.component.scss'],
})
export class OwnProductsDialogComponent {
    constructor(
        private dialogRef: DialogRef,
        @Inject(DIALOG_DATA)
        public data: {
            products: ProductsList;
        }
    ) {}

    addProduct(idProduct: number) {
        this.dialogRef.close(idProduct);
    }

    close() {
        this.dialogRef.close(null);
    }
}
